<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title>Sellers</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="refreshList()">
        <v-icon>autorenew</v-icon>
      </v-btn>
      <v-btn icon @click.stop="rightDrawer = !rightDrawer">
        <v-icon>filter_list</v-icon>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer
      temporary
      right
      v-model="rightDrawer"
      fixed
      app
      :width=500
    >
      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex
            xs12
            text-xs-center
            layout
            align-center
            justify-center
            class="pl-4 pr-4"
          >
            <v-form ref="form" v-model="frmValid">
              <v-text-field
                v-model="txtName"
                label="Name"
              ></v-text-field>
              <v-select
                v-model="cboSort"
                :items="sorts"
                item-text="caption"
                item-value="value"
                label="Sorting"
              ></v-select>
              <v-btn
                :disabled="!frmValid"
                @click="items=[]; getSellers(txtName, cboSort); rightDrawer=false;"
              >
                Filter
              </v-btn>
              <v-btn @click="clearFilter">Reset</v-btn>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
    <v-content>
      <v-list two-line fill-height v-if="items.length > 0">
        <template
          v-for="(item, index) in items"
        >
          <v-list-tile
            :key="item.customerId"
            avatar
            ripple
            :class="(index % 2 === 0 ? 'row1' : 'row2')"
          >
            <v-list-tile-action>
              <v-list-tile-action-text>
                <v-btn outline class="mr-4" v-if="isSuperUser" @click="loginAsSeller(item.userId)">
                  Login
                </v-btn>
              </v-list-tile-action-text>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.storeName }} <span :class="getStylesForType(item.type)">{{ item.type | allCaps }}</span>
                <span class="subheading font-weight-bold white--text pl-3">({{ item.storeCurrencyCode }})</span>
              </v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">
                {{ item.loginEmail }}
              </v-list-tile-sub-title>
              <v-list-tile-sub-title>
                Total purchase:
                <router-link :to="'/customer/' + item.userId + '/orders'" class="white--text">
                  {{ def.currency.sign }}{{ formatPrice(item.totalPurchase) }}
                </router-link>
              </v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-list-tile-action-text>
                Last order: {{ item.lastOrderDateTimeDisplay }}
              </v-list-tile-action-text>
              <v-btn outline small class="pl-2 pr-2" v-if="isAccessTransaction" :to="'/seller/' + item.userId + '/transactions'">
                Balance: {{ def.currency.sign }}{{ formatPrice(item.cacheBalanceAmount) }}
              </v-btn>
            </v-list-tile-action>

            <v-btn icon class="ml-3" color="primary" :to="'/seller/' + item.userId" >
              <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>

          </v-list-tile>
          <v-divider
            v-if="index + 1 < items.length"
            :key="index"
          ></v-divider>
        </template>
        <template
          v-if="items.length <= 0"
        >
          <v-flex
            xs12
            justify-center
            align-center
            text-xs-center
          >
            <v-icon x-large color="primary">error_outline</v-icon>
            <div>
              No seller yet
            </div>
          </v-flex>
        </template>
      </v-list>
      <!--<v-fab-transition>
        <v-btn
          color=primary
          dark
          fab
          fixed
          bottom
          right
          class="mr-5"
          to="/seller"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-fab-transition>-->
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import axios from 'axios'
import router from '../router'
import moment from 'moment'

export default {
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      rightDrawer: false,
      loading: false,
      frmValid: true,
      txtName: '',
      cboSort: null,
      sorts: [
        {
          caption: 'Latest',
          value: 'createdDateTime:desc'
        },
        {
          caption: 'Name',
          value: 'firstName:asc'
        }
      ],
      isAccessTransaction: false,
      isSuperUser: false,
      items: [],
      listLimit: 15,
      listOffset: 0,
      listTotal: 0
    }
  },

  mounted () {
    this.openDrawerForDesktop()
    this.getSellers()
    this.detectBottomOfWindow()

    if (typeof this.profile.permissions !== 'undefined') {
      for (var i in this.profile.permissions) {
        if (this.profile.permissions[i].permissionId === 'PEM-TRANSACTION' && this.profile.permissions[i].isRead === '1') {
          this.isAccessTransaction = true
        }
        if (this.profile.permissions[i].permissionId === 'PEM-ADMIN' && this.profile.permissions[i].isCreate === '1') {
          this.isSuperUser = true
        }
      }
    }
  },

  methods: {
    getStylesForType: function (type) {
      var styles = 'white--text caption pa-2 ml-2'
      if (type === 'branch') {
        styles = styles + ' red'
      } else if (type === 'franchise') {
        styles = styles + ' orange'
      } else if (type === 'seller' || type === 'virtual') {
        styles = styles + ' blue'
      }
      return styles
    },
    refreshList: function () {
      this.items = []
      var _this = this
      return new Promise(function (resolve, reject) {
        var promise = _this.getSellers(_this.txtName, _this.cboSort, 0)
        promise.then(function () {
          resolve()
        })
      })
    },
    detectBottomOfWindow: function () {
      window.onscroll = () => {
        // console.log(document.documentElement.scrollTop + window.innerHeight) - 48;
        // console.log(document.documentElement.offsetHeight);
        let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight
        if (bottomOfWindow) {
          if (this.listTotal > this.items.length) {
            this.getSellers(this.txtName, this.cboSort, this.items.length)
          }
        }
      }
    },
    getSellers: function (name = '', sort = '', offset = 0) {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/users?type=seller,virtual,branch,franchise&name=' + name + '&sort=' + sort + '&limit=' + _this.listLimit + '&offset=' + offset)
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              for (var c = 0; c < resp.data.data.length; ++c) {
                if (resp.data.data[c].lastOrderDateTime) {
                  resp.data.data[c].lastOrderDateTimeDisplay = moment(resp.data.data[c].lastOrderDateTime, _this.iso8601Format()).fromNow()
                } else {
                  resp.data.data[c].lastOrderDateTimeDisplay = 'No order yet'
                }
              }
              _this.items = _this.items.concat(resp.data.data)
              _this.listLimit = resp.data.limit
              _this.listOffset = resp.data.offset
              _this.listTotal = resp.data.total
            } else {
              console.log('unable to load sellers: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              _this.loading = false
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
            }
          })
      })
      return promise
    },
    clearFilter () {
      this.$refs.form.reset()
      this.items = []
      this.getSellers(this.txtName, this.cboSort)
      this.rightDrawer = false
    },
    loginAsSeller: function (sellerUserId) {
      var _this = this
      var promise = new Promise(function (resolve, reject) {
        _this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/user/' + sellerUserId + '/login/user')
          .then(resp => {
            _this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              window.open(_this.def.sellerDomain + '/login/token/' + resp.data.data.token)
            } else {
              window.alert('unable to login as seller: ' + resp.data.message)
            }
            resolve()
          })
          .catch(function (error) {
            if (error.response) {
              _this.loading = false
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
                reject(error.response.status)
              } else if (error.response.status === 403) {
                _this.showAlert(error)
                reject(error.response.status)
              }
            }
          })
      })
      return promise
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.tabs__slider {
  height: 3px;
}

form {
  width: 100%;
}

</style>
